import { useContext } from 'react';
import { IStepsContext, StepsContext } from './StepsContext';

export const useSteps = () => useContext<IStepsContext>(StepsContext);
